import { render } from "./error.vue?vue&type=template&id=f627e7d4&ts=true"
import script from "./error.ts?vue&type=script&lang=ts&external"
export * from "./error.ts?vue&type=script&lang=ts&external"

import "./error.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__